export default __webpack_public_path__ + "static/media/UnoPie- Design Agency.d8a37d28.png";